import { Checkbox, Divider } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import { FooterFlex } from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/InterviewerDrawer/style'
import React, { Fragment, useEffect, useState } from 'react'
import { LastContent, SubHeader } from '../UploadDocumentsDrawer/style'

const UploadDetailsDrawer = ({
  selectedDocType,
  onClose,
  updateSelectedDocuments,
  selectedDocuments,
  onAddressMandatory,
  addressSelectedDocuments,
  indentitySelectedDocuments,
}) => {
  const [selectedDocs, setSelectedDocs] = useState(
    selectedDocType === 'ADDRESS'
      ? [...addressSelectedDocuments]
      : [...indentitySelectedDocuments]
  )
  const [selectedDocIds, setSelectedDocIds] = useState([])

  useEffect(() => {
    if (selectedDocType === 'ADDRESS') {
      addressSelectedDocuments?.map(doc => {
        setSelectedDocIds(prevSelectedDocIds => [...prevSelectedDocIds, doc.id])
      })
    }
    if (selectedDocType === 'IDENTITY_PROOF') {
      indentitySelectedDocuments?.map(doc => {
        setSelectedDocIds(prevSelectedDocIds => [...prevSelectedDocIds, doc.id])
      })
    }
  }, [addressSelectedDocuments, indentitySelectedDocuments])

  const toggleDocumentSelection = doc => {
    const isSelected = selectedDocs?.some(
      selectedDoc => selectedDoc.id === doc.id
    )
    doc.mandatory = onAddressMandatory
    if (isSelected) {
      setSelectedDocs(prevSelectedDocs =>
        prevSelectedDocs.filter(selectedDoc => selectedDoc.id !== doc.id)
      )

      setSelectedDocIds(prevSelectedDocIds =>
        prevSelectedDocIds.filter(id => id !== doc.id)
      )
    } else {
      setSelectedDocs(prevSelectedDocs => [...prevSelectedDocs, doc])

      setSelectedDocIds(prevSelectedDocIds => [...prevSelectedDocIds, doc.id])
    }
  }

  const handleAdd = () => {
    updateSelectedDocuments(selectedDocType, selectedDocs, selectedDocIds)
    onClose()
  }

  const content = () => {
    return (
      <>
        {selectedDocuments?.map((document, index) => (
          <div key={index + 'documents'}>
            {document?.data?.map((doc, index) => {
              return (
                <Fragment key={doc.id}>
                  {index > 0 && (
                    <div>
                      <Divider />
                    </div>
                  )}
                  <Checkbox
                    checked={selectedDocIds.includes(doc.id)}
                    onChange={() => toggleDocumentSelection(doc)}
                  >
                    <SubHeader>{doc.document_name}</SubHeader>
                  </Checkbox>
                </Fragment>
              )
            })}
            <LastContent>
              NOTE: Candidates have to upload any one from the following
              documents.
            </LastContent>
          </div>
        ))}
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary height="38px" text="Cancel" onClick={onClose} />
        <Button.Primary height="38px" text="Add" onClick={handleAdd} />
      </FooterFlex>
    )
  }

  return (
    <Drawer
      width="40%"
      title={`Add Documents`}
      placement="right"
      visible={selectedDocuments}
      onClose={onClose}
      content={content()}
      footer={footer()}
      closable
    />
  )
}

export default UploadDetailsDrawer
